export default {
  meta: {
    title: '任务管理'
  }
};
